import { faUsers } from '@fortawesome/pro-solid-svg-icons';
import {
  GenericSelectorModalConfig,
  GenericNodeComponentConfig,
} from '../shared';

/**
 * Encounter (Provider Cohort) item interface for ui_metadata storage
 */
export interface EncounterItem {
  id: string;
  displayLabel: string;
  label: string;
  name?: string;
  scope?: 'company' | 'personal';
}

/**
 * Transform API response to EncounterItem format
 */
export const transformEncounter = (apiItem: {
  id: string | number;
  label?: string;
  name?: string;
  scope?: 'company' | 'personal';
}): EncounterItem => ({
  id: String(apiItem.id),
  displayLabel: apiItem.label || apiItem.name || String(apiItem.id),
  label: apiItem.label || apiItem.name || String(apiItem.id),
  name: apiItem.name,
  scope: apiItem.scope,
});

/**
 * Modal configuration for Encounter selector
 */
export const encounterModalConfig: GenericSelectorModalConfig<EncounterItem> = {
  title: 'Select Encounter Set',
  searchPlaceholder: 'Search encounter sets...',
  emptyStateIcon: faUsers,
  emptyStateMessage: 'No encounter set selected',
  noResultsMessage: (searchTerm) => `No encounter sets found for "${searchTerm}"`,
  colorTheme: 'orange',
  selectionMode: 'single',
  showConnectorToggle: false,
  defaultConnector: 'ALL',
  getItemLabel: (item) => item.label,
  getItemKey: (item) => item.id,
  isItemSelected: (item, selectedItems) =>
    selectedItems.some((s) => s.id === item.id),
  itemLabel: 'encounter set',
  itemLabelPlural: 'encounter sets',
};

/**
 * Node display configuration for Encounter
 */
export const encounterNodeConfig: GenericNodeComponentConfig<EncounterItem> = {
  colorTheme: 'orange',
  getItemLabel: (item) => item.label,
  getItemKey: (item) => item.id,
  maxVisibleItems: 1, // Single selection
  showConnectorLabel: false,
};
